<template>
  <v-snackbar v-model="snackbar" top right :timeout="timeout">
    {{ snackbarText }}
    <v-btn color="pink" flat @click="snackbar = false">Ok</v-btn>
  </v-snackbar>
</template>

<script>
import SocketService from "@/services/socketApi";
export default {
  data() {
    return {
      socket: SocketService.socket("global"),
      snackbar: false,
      snackbarText: "",
      timeout: 5000
    };
  },
  methods: {
    socketActions() {
      const socket = this.socket;
      socket.on("connect", () => {
        //console.log('socket connected');
        this.showSnack("You are now receiving live updates.");
      });
      socket.on("disconnect", () => {
        //console.log('socket disconnected');
        this.showSnack("No longer receiving live updates.");
      });
      socket.on("newDocket", data => {
        //console.log(data);
        var item = data.result;
        item.user = data.user;
        this.items.unshift(item);

        this.showSnack(data.message);
      });
      socket.on("timeStamp", data => {
        //console.log(data)
      });
      socket.on("created", data => {
        if (!this.arrayEmpty(data.resourceType)) {
          this.$store.commit(`${data.resourceType}/addToArrayState`, {
            prop: data.resourceType,
            value: data.result
          });
        }
        //console.log(data);
      });
      socket.on("deleted", data => {
        this.$store.commit(`${data.resourceType}/deleteFromArrayStateById`, {
          prop: data.resourceType,
          id: data.result.id
        });
      });
    },
    arrayEmpty(resourceType) {
      return !this.$store.state[resourceType][resourceType].length;
    },
    showSnack(text) {
      this.snackbarText = text;
      this.snackbar = true;
    }
  },
  mounted() {
    this.socket.connect();
    this.socketActions();
  },
  beforeDestroy() {
    this.socket.disconnect();
  }
};
</script>

<style>
</style>
